export default __webpack_public_path__ + "static/media/bannerXmasMb.59e75270.png";